import TickerRepository from './ticker-repository';
import createTickerElement from './ticker-element-factory';

class TickerObserver {
	constructor() {
		this.underlyingRepository = new TickerRepository('underlying');
		this.productRepository = new TickerRepository('product');

		this.tickerElementInstances = new Map();

		this.start();
	}

	start() {
		this.createTickers();
	}

	createTickers(root = document.body) {
		const elements = TickerObserver.getTickerElements(root);

		elements.forEach(this.createTicker, this);
	}

	createTicker(el) {
		this.subscribe(el);

		const tickerElementInstance = createTickerElement(el);

		this.tickerElementInstances.set(el, tickerElementInstance);

		return tickerElementInstance;
	}

	destroyTicker(el) {
		const tickerElementInstance = this.tickerElementInstances.get(el);

		if (!tickerElementInstance) {
			return;
		}

		tickerElementInstance.destroy();
	}

	addTickers(DOMelement) {
		TickerObserver
			.getTickerElements(DOMelement)
			.forEach(this.createTicker, this);
	}

	removeTickers(DOMElement) {
		TickerObserver
			.getTickerElements(DOMElement)
			.forEach((el) => {
				this.destroyTicker(el);
				this.unsubscribe(el);
			});
	}

	getSubscriptionInfo(element) {
		return {
			subscriptionId: TickerObserver.getSubscriptionId(element),
			repo: this.getElementRepo(element),
		};
	}

	subscribe(element) {
		const { subscriptionId, repo } = this.getSubscriptionInfo(element);

		repo.add(subscriptionId);
	}

	unsubscribe(element) {
		const { subscriptionId, repo } = this.getSubscriptionInfo(element);

		repo.remove(subscriptionId);
	}

	getElementRepo(element) {
		const { dataset: { isin } } = element;

		const repo = isin
			? this.productRepository
			: this.underlyingRepository;

		return repo;
	}

	static getSubscriptionId(element) {
		const { dataset: { isin, underlyingKey } } = element;

		return isin || underlyingKey;
	}

	static getTickerElements(DOMelement) {
		return [...DOMelement.querySelectorAll(`
			[data-underlying-key],
			[data-isin]
		`)];
	}
}

export default new TickerObserver();
